import { apiClient } from './client';

export const evaluateApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        getEvaluate: builder.query<any, any>({
            query: ({ book_id, product_type }) => {
                return {
                    url: `/api/books/evaluate?book_id=${book_id}&product_type=${product_type}`
                }
            },
        }),
    }),
});

export const { useGetEvaluateQuery } = evaluateApi;